<template>
  <v-menu ref="menu1"
  v-model="menu1"
  :close-on-content-click="false"
  transition="scale-transition"
  offset-y
  min-width="auto">
    <template v-slot:activator="{ on }">
      <v-text-field class="my-0 py-1"
        placeholder="YYYY-MM-DD"
        autocomplete="off"
        :prepend-icon="prependIcon"
        v-model="selected"
        single-line
        :required="required"
        :disabled="disabled"
        v-on:input="$emit('input', $event)"
        @blur="date = parseDate(value)"
        v-on="on"
        :dense="dense"
        :outlined="outlined"
        readonly
        value
        @focus="handleFocus"
      />
    </template>
    <v-date-picker v-model="selected" @input="menu1 = false" no-title :max="maxToDate" :min="minToDate"/>
  </v-menu>
</template>

<script>
export default {
  name: 'CustomDatePicker',
  props: {
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    maxToDate: {
      type: String,
      default: null
    },
    minToDate: {
      type: String,
      default: null
    },
    prependIcon: {
      type: String,
      default: null
    },
    dense: {
      type: String,
      default: null
    },
    outlined: {
      type: String,
      default: null
    }

  },

  data () {
    return {
      menu1: null,
      date: null
    }
  },

  computed: {
    selected: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  watch: {
    date (val) {
      this.value = this.formatDate(this.date)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      return date
    },
    parseDate (date) {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    handleFocus (event) {
      this.$emit('focus', event)
    }
  }
}
</script>
